module.exports = __webpack_public_path__ + "static/media/Cricket-2.d6da1c00.svg";